import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface ModalPortalProps {
  children?: React.ReactNode | React.ReactNode[];
}

const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = document.createElement('div');
    setContainer(el);
    document.body.appendChild(el);

    return () => {
      document.body.removeChild(el);
    };
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(children, container);
};

export default ModalPortal;
